module.exports = __webpack_public_path__ + "static/img/bg29.c9e64aac.png";